const requestVariableSettings = {
  label: 'Request Variable',
  name: 'config',
  helper: 'Enter the request variable that will store the signal payload',
  'data-cy': 'signal-request-variable',
};

export default requestVariableSettings;
